import { createContext, useContext, useCallback, useState } from 'react';
import { AvailabilityUpdatedMessage } from 'types/availability';
import { useAvailabilitySignalr } from 'hooks/useAvailabilitySignalr';

type AvailabilityState = Record<
  string,
  {
    isProviderInQueue: boolean;
    unavailable: boolean;
  }
>;

const AvailabilityContext = createContext<AvailabilityState>({});

export function AvailabilityProvider({ children }: { children: React.ReactNode }) {
  const [availabilityMap, setAvailabilityMap] = useState<AvailabilityState>({});

  const handleUpdate = useCallback((msg: AvailabilityUpdatedMessage) => {
    setAvailabilityMap((prev) => ({
      ...prev,
      [msg.providerId]: {
        isProviderInQueue: msg.isProviderInQueue,
        unavailable: msg.unavailable,
      },
    }));
  }, []);

  useAvailabilitySignalr(handleUpdate);

  return <AvailabilityContext.Provider value={availabilityMap}>{children}</AvailabilityContext.Provider>;
}

export function useAvailability() {
  return useContext(AvailabilityContext);
}
